import React from "react";
import { Image, Link, Modal, Spin, Table, Typography } from "@arco-design/web-react";
import { IconFile } from "@arco-design/web-react/icon";

import { formatBytes, formatDimensions, thumbUrl } from "./fileMeta";

const { Text } = Typography;

const TYPE_NAMES = { "image/jpeg": "JPEG", "image/png": "PNG", "image/gif": "GIF", "image/webp": "WebP" };

// FileVersionsModal shows every stored copy of an image: the full-size
// original (if kept), the one in Files, the one forms and emails use, and the
// thumbnail. versions is null while they load.
export default function FileVersionsModal({ file, versions, onClose }) {
  // The small picture is the thumbnail for every row, so opening the window
  // doesn't download an 18 MB original; clicking opens that version itself.
  const small = file && thumbUrl(file);
  const columns = [
    {
      title: "",
      dataIndex: "url",
      width: 64,
      render: (url, v) =>
        v.content_type && v.content_type.startsWith("image/") ? (
          <Image
            src={v.kind === "thumb" ? url : small || url}
            previewProps={{ src: url }}
            alt={v.label}
            width={48}
            height={48}
            style={{ objectFit: "contain", background: "var(--color-fill-2)", borderRadius: 2 }}
            error={<IconFile />}
          />
        ) : (
          <IconFile style={{ fontSize: 20, color: "var(--color-text-3)" }} />
        ),
    },
    {
      title: "Version",
      dataIndex: "label",
      render: (label, v) => (
        <>
          <Text bold>{label}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>{v.note}</Text>
        </>
      ),
    },
    { title: "Size", dataIndex: "size", render: (size) => formatBytes(size) },
    { title: "Dimensions", dataIndex: "width", render: (_, v) => formatDimensions(v) },
    { title: "Type", dataIndex: "content_type", render: (t) => TYPE_NAMES[t] || t },
    {
      title: "",
      dataIndex: "open",
      render: (_, v) => (
        <Link href={v.url} target="_blank" rel="noopener noreferrer">Open</Link>
      ),
    },
  ];

  return (
    <Modal
      title={file ? `Versions of ${file.name}` : "Versions"}
      visible={!!file}
      onCancel={onClose}
      footer={null}
      style={{ width: 760, maxWidth: "95vw" }}
    >
      {versions ? (
        <Table size="small" rowKey="kind" columns={columns} data={versions} pagination={false} />
      ) : (
        <div style={{ textAlign: "center", padding: 24 }}><Spin /></div>
      )}
    </Modal>
  );
}
